import { Injectable } from '@angular/core';
import { DeadlineDateCalcualator } from '@zaoblako/shared/common/classes/deadline.date.calcualator';
import { TemplateEntityVariableEngine } from '@zaoblako/shared/common/classes/template.entity.variable.engine';
import type { DocumentTemplateFindInterface } from '@zaoblako/shared/modules/document/dtos/document-template/document-template-find.dto';
import type { DocumentCreateInterface } from '@zaoblako/shared/modules/document/dtos/document/document-create.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DocumentTemplateService extends BaseService {
  protected baseUrl = '/document/template';

  public getDocumentFormByTemplate(id: number): Observable<DocumentCreateInterface> {
    return this.findById<DocumentTemplateFindInterface>(id).pipe(
      map((template) => {
        const document = <DocumentCreateInterface>{};
        const fieldsToCopy: Array<keyof DocumentTemplateFindInterface> = [
          'contragent',
          'company',
          'filial',
          'unit',
          'direction',
          'type',
          'operationType',
          'amount',
          'deal',
          'commentary',
          'currency'
        ];

        fieldsToCopy.forEach((field) => (document[field] = template[field]));
        if (template.commentary) {
          document.commentary = TemplateEntityVariableEngine.getInstance().parse(template.commentary);
        }

        if (template.type) {
          document.documentType = template.type;
        }

        document.date = DeadlineDateCalcualator.getInstance().calculateDate(
          template.deadline,
          template.planning.nearestDate || template.planning.runDate
        );

        return document;
      })
    );
  }
}
